import React, { useState } from 'react';
import { 
  FaBullhorn, 
  FaCode, 
  FaFacebook, 
  FaGoogle, 
  FaSearch, 
  FaWordpress, 
  FaShopify, 
  FaReact,
  FaArrowRight,
  FaCheck
} from 'react-icons/fa';
import './Welcome.css';

const Welcome = ({ onServiceSelect }) => {
  const [selectedServices, setSelectedServices] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);

  const services = [
    {
      id: 'digital-marketing',
      title: 'Digital Marketing',
      icon: FaBullhorn,
      description: 'Transform your online presence with strategic marketing',
      features: [
        'Social Media Management',
        'Meta & Facebook Ads',
        'Google Ads & PPC',
        'Content Creation',
        'SEO Optimization'
      ],
      color: '#ff6b6b',
      gradient: 'linear-gradient(135deg, #ff6b6b, #ee5a24)'
    },
    {
      id: 'web-development',
      title: 'Website Development',
      icon: FaCode,
      description: 'Build powerful websites that convert visitors to customers',
      features: [
        'Custom Web Development',
        'WordPress Solutions',
        'Shopify E-commerce',
        'Frontend & Backend',
        'Responsive Design'
      ],
      color: '#4ecdc4',
      gradient: 'linear-gradient(135deg, #4ecdc4, #44a08d)'
    }
  ];

  const handleServiceToggle = (serviceId) => {
    setSelectedServices(prev => {
      if (prev.includes(serviceId)) {
        return prev.filter(id => id !== serviceId);
      } else {
        return [...prev, serviceId];
      }
    });
  };

  const handleContinue = () => {
    if (selectedServices.length > 0) {
      onServiceSelect(selectedServices);
    }
  };

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <div className="welcome-header">
          <h1 className="welcome-title">
            Digital Marketing Expert & Web Developer in Ahmedabad - <span className="highlight">Harish Kumar</span>
          </h1>
          <p className="welcome-subtitle">
            Transform your business with proven digital marketing strategies and custom web development solutions. Choose your service below to see targeted results and portfolio examples.
          </p>
          
          {/* SEO Content Section */}
          <div className="seo-content">
            <h2>Expert Digital Marketing & Web Development Services</h2>
            <p>
              As a leading <strong>digital marketing expert in Ahmedabad</strong>, I specialize in delivering measurable results through strategic Facebook Ads, Google Ads, and comprehensive SEO services. My web development expertise includes creating high-performance React applications, WordPress solutions, and custom e-commerce platforms that convert visitors into customers.
            </p>
            
            <h3>Digital Marketing Services</h3>
            <p>
              Drive real business growth with my proven digital marketing strategies. I've helped businesses achieve over 300% ROI through targeted Facebook advertising, Google Ads optimization, and data-driven social media marketing campaigns. My approach combines creative content strategy with advanced analytics to maximize your marketing investment.
            </p>
            
            <h3>Web Development Solutions</h3>
            <p>
              Get a modern, responsive website that works perfectly across all devices. I build custom web applications using React, develop robust WordPress sites, and create powerful e-commerce platforms. Every project includes SEO optimization, mobile responsiveness, and fast loading speeds to boost your online presence.
            </p>
            
            <p>
              <strong>Ready to grow your business?</strong> Select your service area below to see relevant <a href="#portfolio">case studies</a>, <a href="#testimonials">testimonials</a>, and <a href="#pricing">pricing options</a> tailored specifically for your needs. Whether you need digital marketing, web development, or both, I'll help you achieve your business goals.
            </p>
            
            <div className="quick-links">
              <h3>Explore My Work:</h3>
              <ul>
                <li><a href="#about">About Harish Kumar</a> - Learn about my expertise and background</li>
                <li><a href="#portfolio">Portfolio Gallery</a> - See successful campaigns and web projects</li>
                <li><a href="#skills">Technical Skills</a> - View my digital marketing and development capabilities</li>
                <li><a href="#contact">Get In Touch</a> - Start your project with a free consultation</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services-selection">
          <div className="services-grid">
            {services.map((service) => (
              <div
                key={service.id}
                className={`service-selection-card ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => handleServiceToggle(service.id)}
                onMouseEnter={() => setHoveredCard(service.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  '--service-color': service.color,
                  '--service-gradient': service.gradient
                }}
              >
                <div className="service-icon-container">
                  <service.icon className="service-selection-icon" />
                  {selectedServices.includes(service.id) && (
                    <div className="selection-indicator">
                      <FaCheck />
                    </div>
                  )}
                </div>
                
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  
                  <ul className="service-features">
                    {service.features.map((feature, index) => (
                      <li key={index} className="service-feature">
                        <FaCheck className="feature-check" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="service-hover-overlay">
                  <span className="select-text">
                    {selectedServices.includes(service.id) ? 'Selected ✓' : 'Click to Select'}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="selection-actions">
            <div className="selection-summary">
              {selectedServices.length === 0 && (
                <p className="selection-hint">Select one or more services to continue</p>
              )}
              {selectedServices.length === 1 && (
                <p className="selection-text">Great choice! You've selected <strong>1 service</strong></p>
              )}
              {selectedServices.length === 2 && (
                <p className="selection-text">Perfect! You've selected <strong>both services</strong></p>
              )}
            </div>

            <button 
              className={`continue-btn ${selectedServices.length > 0 ? 'active' : ''}`}
              onClick={handleContinue}
              disabled={selectedServices.length === 0}
            >
              Continue to Portfolio <FaArrowRight />
            </button>
          </div>
        </div>

        <div className="welcome-footer">
          <p className="welcome-note">
            Your selection helps me show you the most relevant work and expertise for your needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
